import React from 'react';

interface VerticalGapProps {
    height: number;
}

const VerticalGap: React.FC<VerticalGapProps> = ({ height }) => {
    return (
        <div style={{ height: `${height}px`,width:1 }} />
    );
};

export default VerticalGap;
